<template>
  <div class="center">
    <div>
      <div class="center" v-if="error" style="color: #000">
        <p><b style="color: #ff0000">ERRO AO TENTAR ABRIR A CÂMERA </b></p>
        <p class="f16">
          SEU DISPOSITIVO NÃO PERMITIU ABRIR A CAMERA, CONFIRA SE ELA ESTÁ
          INSTALADA, VOCÊ TAMBEM PODE FAZER SUA INSCRIÇÃO COM UM COMPUTADOR E
          UMA WEBCAM, OU UM CELULAR COM CAMERA, RECOMENDAMOS O NAVEGADOR
          <b>Chrome</b>
          VOCÊ PODE BAIXA-LO E TENTAR NOVAMENTE
        </p>
        <p>
          SE VOCÊ CLICOU PARA NÃO PERMITIR A CAMERA QUANDO A PAGINA INICIOU,
          PODE RECARREGAR ESSA PAGINA PARA ACEITAR NOVAMENTE, OU ENCONTRAR O
          ICONE DE CAMERA NA PARTE SUPERIOR DO NAVEGADOR E ACEITAR A PERMISSÃO
        </p>

        <!-- Caixa de erro detalhado para suporte -->
        <div
          v-if="initializationError"
          style="
            margin-top: 20px;
            padding: 15px;
            border: 2px solid #ff0000;
            border-radius: 8px;
            background-color: #fff5f5;
          "
        >
          <p><b style="color: #ff0000">DETALHES TÉCNICOS DO ERRO:</b></p>
          <p
            style="
              font-family: monospace;
              font-size: 14px;
              color: #333;
              word-break: break-all;
            "
          >
            {{ initializationError }}
          </p>
          <p style="color: #666; font-size: 14px; margin-top: 10px">
            <b>📸 PARA O SUPORTE:</b> Tire um print desta tela e envie para
            nossa equipe de suporte técnico. Essas informações nos ajudarão a
            identificar e resolver o problema rapidamente.
          </p>
          <button
            @click="copyErrorToClipboard"
            style="
              background-color: #007bff;
              color: white;
              border: none;
              padding: 8px 16px;
              border-radius: 4px;
              cursor: pointer;
              margin-top: 10px;
            "
          >
            📋 COPIAR ERRO
          </button>
        </div>
      </div>
      <video
        :id="`candidateQuestion${index}`"
        class="video-js vjs-default-skin"
        playsinline
      ></video>
      <div
        v-show="recordStart"
        :class="{ textTimer: timerPlay < 0 ? true : false }"
        class="timerCount"
      >
        {{ timerPlay >= 0 ? timerPlay : "Gravando" }}
      </div>
    </div>
    <div class="control-video">
      <button
        v-if="
          (!isRecord && recruiter) ||
          (!isRecord && timerPlay > 3 && retakers < question.number_retakers)
        "
        @click="startRecord"
        type="button"
        class="btn mt-5 btn-success btn-lg mr-1"
      >
        {{ retakers == 0 ? "COMEÇAR A GRAVAR" : "REGRAVAR RESPOSTA" }}
      </button>

      <button
        v-if="retakers != 0 && !isRecord && timerPlay > 3 && !recruiter"
        type="button"
        class="btn btn-lg mr-1 mt-5 btn-primary"
        @click="nextQuestion"
      >
        ENVIAR VÍDEO
      </button>

      <button
        @click="stopRecord"
        v-if="isRecord"
        class="btn btn-lg mt-5 btn-danger"
      >
        PARAR GRAVAÇÃO
      </button>
    </div>
    <span v-if="!recruiter">
      <span
        v-if="
          retakers != 0 &&
          !isRecord &&
          retakers < question.number_retakers &&
          timerPlay > 3
        "
        class="color-grey"
        >VOCÊ TEM MAIS {{ question.number_retakers - retakers }}
        {{
          question.number_retakers - retakers == 1 ? "TENTATIVA" : "TENTATIVAS"
        }}</span
      >
    </span>
    <div v-if="question.choices.canBeEmpty">
      <button @click="nextQuestion(false)" class="btn btn-primary full mt-2">
        Pular
      </button>
    </div>
  </div>
</template>

<script>
import "webrtc-adapter";

import videojs from "video.js";

import Record from "videojs-record/dist/videojs.record.js";
import axios from "axios";
export default {
  props: [
    "question",
    "index",
    "recruiter",
    "job_id",
    "currentTime",
    "is_evaluation",
  ],
  data() {
    return {
      isRecord: false,
      recordStart: false,
      timerStart: "",
      timerPlay: 4,
      player: "",
      retakers: 0,
      error: false,
      loadding: false,
      isVideoJSSupported: true,
      isWebRTCSupported: true,
      initializationError: null,
      options: {
        controls: true,
        autoplay: false,
        loop: false,
        fluid: true,
        // width: 540,
        // height: 340,
        controlBar: {
          deviceButton: false,
          recordIndicator: false,
          fullscreenToggle: false,
          volumePanel: false,
          cameraButton: false,
          pipToggle: true,
          recordToggle: false,
        },
        plugins: {
          // configure videojs-record plugin
          record: {
            image: false,
            audio: true,
            video: true,
            pip: true,
            debug: true,
            maxLength: 2,
            videoMimeType: "video/mp4",
          },
        },
      },
    };
  },
  watch: {
    timerPlay(val) {
      if (val == -2) {
        this.recordStart = false;
        clearInterval(this.timerStart);
        this.player.record().start();
        this.timerPlay = 4;
      }
    },
    question() {
      this.player.dispose();
    },
  },
  methods: {
    nextQuestion(show_message = true) {
      if (show_message) this.$toast.success("Vídeo enviado com sucesso");
      if (this.is_evaluation) {
        this.$emit("nextQuestion", "true");
        return;
      }
      eventBus.$emit("nextQuestion", this.index);
    },
    copyErrorToClipboard() {
      const errorInfo = `
ERRO TÉCNICO - JOVOOL GRAVAÇÃO DE VÍDEO
========================================
Data/Hora: ${new Date().toLocaleString()}
Erro: ${this.initializationError}
Navegador: ${navigator.userAgent}
Plataforma: ${navigator.platform}
WebRTC Suportado: ${this.isWebRTCSupported}
VideoJS Suportado: ${this.isVideoJSSupported}
Permissões de Mídia: ${navigator.permissions ? "Disponível" : "Não disponível"}
========================================
      `.trim();

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(errorInfo)
          .then(() => {
            this.$toast.success(
              "Informações do erro copiadas! Cole no suporte."
            );
          })
          .catch(() => {
            this.fallbackCopyToClipboard(errorInfo);
          });
      } else {
        this.fallbackCopyToClipboard(errorInfo);
      }
    },
    fallbackCopyToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
        this.$toast.success("Informações do erro copiadas!");
      } catch (err) {
        this.$toast.error("Não foi possível copiar. Tire um print da tela.");
      }

      document.body.removeChild(textArea);
    },
    stopRecord() {
      this.player.record().stop();
      eventBus.$emit("videoRecorded");
    },
    startRecord() {
      this.timerPlay = 3;
      this.retakers++;
      this.recordStart = true;
      this.timerStart = setInterval(() => this.timerPlay--, 1000);
    },
    getThumbnail(player) {
      let canvas = document.createElement("canvas");
      canvas.className = "hide";
      canvas.width = 320;
      canvas.height = 240;
      document.getElementsByTagName("body")[0].appendChild(canvas);

      // draw video frame
      let context = canvas.getContext("2d");
      context.drawImage(
        player.record().mediaElement,
        0,
        0,
        canvas.width,
        canvas.height
      );
      return canvas;
    },
    upload(blob) {
      this.loadding = true;
      let player = blob.recordedData;
      let canvas = this.getThumbnail(blob);
      let formData = new FormData();

      canvas.toBlob((thumb) => {
        if (!this.recruiter) {
          formData.append("answers[thumbnail]", thumb);
          formData.append("answers[video]", player, player.name);
          formData.append("answers[question_id]", this.question.id);
          formData.append(
            "answers[evaluation_id]",
            this.question.evaluation_id
          );
          if (this.currentTime) {
            formData.append("answers[time_taken]", this.currentTime);
          }
          axios
            .post("/candidates/answers", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(function (data) {
              // console.log(data);
            })
            .catch(function (error) {
              // console.log(error);
            });
          return;
        }

        let question_current = {};
        question_current.id = this.question.id;
        question_current.title = this.question.title;
        question_current.description = this.question.description;
        question_current.time = this.question.time;
        question_current.number_retakers = this.question.number_retakers;
        question_current.details = this.question.details;
        question_current.job_id = this.question.job_id;
        question_current.video_id = this.question.video_id;
        question_current.selective_process_id =
          this.question.selective_process_id;

        axios
          .post("/recruiters/questions", {
            questions: {
              job_id: this.job_id,
              itens: [question_current],
            },
          })
          .then((response) => {
            this.question.id = response.data.question.id;
            formData.append("video[thumbnail]", thumb);
            formData.append("video[file]", player, player.name);
            formData.append("video[name]", this.question.title);
            formData.append("video[question_id]", this.question.id);
            formData.append("video[job_id]", this.job_id);
            formData.append("video[recruiter_id]", 0);
            formData.append("video[account_id]", 0);
            axios
              .post("/recruiters/question_videos", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((resp) => {
                this.question.video_id = resp.data.question.video_id;
                this.question.video = resp.data.video;
              })
              .catch(function (error) {
                console.log(error);
              });
          });
        return;
      });
    },
    async checkMediaPermissions() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });

        stream.getTracks().forEach((track) => track.stop());

        return true;
      } catch (error) {
        console.error("Erro ao verificar permissões de mídia:", error);

        if (error.name === "NotAllowedError") {
          this.initializationError = "Permissão de câmera/microfone negada";
        } else if (error.name === "NotFoundError") {
          this.initializationError = "Câmera ou microfone não encontrados";
        } else if (error.name === "NotReadableError") {
          this.initializationError =
            "Câmera ou microfone em uso por outro aplicativo";
        } else {
          this.initializationError = "Erro ao acessar câmera/microfone";
        }

        throw error;
      }
    },

    initializeVideoJS() {
      try {
        this.player = videojs(
          `#candidateQuestion${this.index}`,
          this.options,
          () => {
            console.log("VideoJS inicializado com sucesso");
          }
        );

        this.setupVideoJSEvents();

        setTimeout(() => {
          if (!this.player || !this.player.record) {
            throw new Error("VideoJS não foi inicializado corretamente");
          }
        }, 3000);
      } catch (error) {
        console.error("Erro ao inicializar VideoJS:", error);
        this.error = true;
        this.initializationError = error.message;
        eventBus.$emit("errorCam", true);
      }
    },

    setupVideoJSEvents() {
      this.player.on("startRecord", () => {
        this.error = false;
        this.isRecord = true;
      });

      this.player.on("finishRecord", () => {
        this.isRecord = false;
        this.loadding = true;
        this.error = false;
        this.stopRecord();

        this.upload(this.player); //.recordedData, );
      });

      this.player.on("error", (element, error) => {
        console.error("Erro do VideoJS:", error);
        this.error = true;
        this.initializationError = "Erro interno do player de vídeo";
        eventBus.$emit("errorCam", true);
      });

      this.player.on("deviceError", () => {
        this.error = true;
        this.initializationError = "Erro no dispositivo de mídia";
        eventBus.$emit("errorCam", true);
        // console.log("device error:", this.player.deviceErrorCode);
      });

      this.player.record().setVideoInput(MediaDeviceInfo.deviceId);
    },
  },
  async mounted() {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.isWebRTCSupported = false;
        this.error = true;
        this.initializationError = "WebRTC não é suportado neste navegador";
        eventBus.$emit("errorCam", true);
        return;
      }

      await this.checkMediaPermissions();

      if (!this.recruiter) {
        this.options.plugins.record.maxLength = this.question.time + 1;
      } else {
        this.options.plugins.record.maxLength = 180;
      }

      await this.$nextTick();

      const videoElement = document.querySelector(
        `#candidateQuestion${this.index}`
      );
      if (!videoElement) {
        throw new Error("Elemento de vídeo não encontrado no DOM");
      }

      this.initializeVideoJS();
    } catch (error) {
      console.error("Erro ao inicializar VideoJS:", error);
      this.error = true;
      this.initializationError = error.message;
      eventBus.$emit("errorCam", true);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
